import { Info } from 'lucide-react';
import type * as React from 'react';
import { cn } from '../lib/utils.js';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip.js';

export interface InfoTooltipProps {
  /** What the tooltip says; also read to screen readers. */
  content: string;
  /** The label the icon explains; the icon is centered beside it. */
  children?: React.ReactNode;
  className?: string;
}

/** A small "i" that opens a tooltip, vertically centered on the label it follows. */
export function InfoTooltip({ content, children, className }: InfoTooltipProps) {
  const icon = (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex shrink-0 items-center justify-center rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          >
            <Info className="size-3.5" aria-hidden />
            <span className="sr-only">{content}</span>
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-64 leading-relaxed">{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
  if (children === undefined) return icon;
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      {children}
      {icon}
    </span>
  );
}
